// src/components/StoreModal/index.js
import React from 'react';
import { APP_STORE_LINK, PLAY_STORE_LINK } from '../../../config';
import {
  ModalOverlay,
  ModalContent,
  ModalTitle,
  ModalButton,
  CloseButton
} from './styles';

const StoreModal = ({ isOpen, onClose, onSelectStore }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <ModalTitle>Escolha sua loja de aplicativos</ModalTitle>
        <ModalButton onClick={() => onSelectStore(APP_STORE_LINK)}>
          App Store
        </ModalButton>
        <ModalButton onClick={() => onSelectStore(PLAY_STORE_LINK)}>
          Google Play
        </ModalButton>
      </ModalContent>
    </ModalOverlay>
  );
};

export default StoreModal;
